export default {
  methods: {
    checkIfHazmatInfoWasFilled(item) {
      const hazmatVariables = [
        "hazmat_class_division",
        "hazmat_number_type",
        "hazmat_packaging_group",
        "hazmat_number",
      ];
      let hazmatInfoFilled = true;
      hazmatVariables.forEach((variable) => {
        if (!item[variable]) {
          hazmatInfoFilled = false;
        }
      });
      return hazmatInfoFilled;
    },
    updateVuexLineItems(data, index, selectedLineItems) {
      const lineItemsCopy = JSON.parse(JSON.stringify(selectedLineItems));
      lineItemsCopy[index] = { ...lineItemsCopy[index], ...data };
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "line_items",
        value: lineItemsCopy,
      });
    },
  },
};
